import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Box, Button, Stack, Typography, Paper } from '@mui/material';
import ExamTimer from './ExamTimer';
import QuestionDisplay from './QuestionDisplay';
import ExamSummary from './ExamSummary';
// TODO: Replace with real API call
import { getExamById } from '../services/indianExamsService';

export default function ExamAttemptPage() {
  const { examId } = useParams();
  const navigate = useNavigate();
  const [exam, setExam] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [current, setCurrent] = useState(0);
  const [answers, setAnswers] = useState({}); // { [questionId]: selectedOption }
  const [submitted, setSubmitted] = useState(false);
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    async function loadExam() {
      setLoading(true);
      try {
        const data = await getExamById(examId);
        if (!data || data.success === false) {
          setError(data?.error || 'Failed to load exam');
          setExam(null);
        } else {
          setExam(data);
          const minutes = data.duration ?? data.exam?.duration ?? 30;
          setTimeLeft((minutes || 30) * 60);
        }
      } catch (e) {
        setError('Failed to load exam');
      } finally {
        setLoading(false);
      }
    }
    loadExam();
  }, [examId]);

  const handleAnswer = (qid, option) => {
    setAnswers(a => ({ ...a, [qid]: option }));
  };

  const handleNext = () => setCurrent(c => Math.min(c + 1, (exam?.questions?.length || 1) - 1));
  const handlePrev = () => setCurrent(c => Math.max(c - 1, 0));

  const handleSubmit = () => setSubmitted(true);

  if (loading) return <Typography>Loading exam…</Typography>;
  if (error) return <Typography color="error">{error}</Typography>;
  if (!exam) return null;

  if (submitted) {
    return <ExamSummary exam={exam} answers={answers} />;
  }

  return (
    <Box maxWidth="md" mx="auto" py={4}>
      <Paper sx={{ p: 3, mb: 2 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography variant="h5">{exam.name}</Typography>
          <ExamTimer seconds={timeLeft} onExpire={handleSubmit} running={!submitted} />
        </Stack>
      </Paper>
      <QuestionDisplay
        question={exam.questions[current]}
        index={current}
        total={exam.questions.length}
        selected={answers[exam.questions[current].id]}
        onSelect={option => handleAnswer(exam.questions[current].id, option)}
      />
      <Stack direction="row" spacing={2} mt={2}>
        <Button onClick={handlePrev} disabled={current === 0}>Previous</Button>
        <Button onClick={handleNext} disabled={current === exam.questions.length - 1}>Next</Button>
        <Button variant="contained" color="primary" onClick={handleSubmit}>Submit Exam</Button>
      </Stack>
    </Box>
  );
}
